<template>
    <div class="text-md-left">
        <finance-config :setting.sync="data.shopDetail.financeConfig" :geoHierarchyData="geoHierarchyData" :provinceArray="provinceArray" :zipcodeArray="zipcodeArray"/>
    </div>
</template>
<script>
// import fgApi from '@/services/fillgoods'
import FinanceConfig from '@/components/Shop/DialogShop/FinanceConfigSetting'
export default {
    name: 'FinanceConfigSetting',
    components: {
        FinanceConfig
    },
    props: {
        data: {
            type: Object,
            default: null
        },
        provinceArray: {
            type: Array,
            default: null
        },
        geoHierarchyData: {
            type: Object,
            default: null
        },
        zipcodeArray: {
            type: Array,
            default: null
        }

    },
    data () {
        return {}
    },
    watch: {},
    created () {
    },
    methods: {

    }
}
</script>
